import { createContext, useContext } from 'react';

export const SelfSchedulingContext = createContext();

export const useSelfSchedulingContext = () => useContext(SelfSchedulingContext);
